import { mergeStyles } from "@fluentui/merge-styles";
import { BORDER_COLOR } from "../../../../config/colors";
import { FONT_SIZE_SMALL, FONT_SIZE_VSMALL } from "../../../../config/fontSizes";

export const wrapperClasses = mergeStyles({
  border: `1px solid ${BORDER_COLOR}`,
  padding: 10,
});

export const stackColumnGap15 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 15,
});

export const stackColumnGap5 = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 5,
});

export const attachmentWrapper = mergeStyles({
  padding: 10,
});
export const attachmentBodyClasses = mergeStyles({
  display: "flex",
});

export const asideClasses = mergeStyles({
  width: 30,
  flexShrink: 0,
});

export const bodyClasses = mergeStyles({});
export const titleClasses = mergeStyles({
  color: "#000",
  fontSize: FONT_SIZE_SMALL,
  marginBottom: 6,
});
export const descriptionClasses = mergeStyles({
  color: "#6e6c69",
  fontSize: "10.5px",
  marginBottom: 6,
  whiteSpace: 'pre-wrap',
});
export const footerClasses = mergeStyles({
  fontSize: FONT_SIZE_SMALL,
  marginBottom: 6,
  display: "flex",
  justifyContent: "space-between",
  color: "#000",
});
export const iconTimerClasses = mergeStyles({
  verticalAlign: "middle",
  marginRight: 5,
});
